import React from "react";
import "./table.scss";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

const renderHeaders = config => {
  return (
    <tr>
      {config.map(col => (
        <th
          key={col.key}
          style={{
            textAlign: col.align ?? "left",
          }}
        >
          {col.header}
        </th>
      ))}
    </tr>
  );
};

export const Table = ({
  tableConfig = [],
  tableData = [],
  onRowClick,
  triggerEndOfPage,
  rowClassName = "",
}) => {
  const endOfPageRef = useIntersectionObserver(
    () => {
      triggerEndOfPage?.();
    },
    { threshold: 0.1 }
  );
  return (
    <div className="tableContainer">
      <table className={"table"}>
        <thead className="tableHead">
          {renderHeaders(tableConfig)}
        </thead>
        <tbody className="tableBody">
          {tableData.map((row, index) => (
            <tr
              key={index}
              onClick={() => onRowClick?.(row)}
              className={`${rowClassName}`}
            >
              {tableConfig.map(col => (
                <td
                  key={col.key}
                  style={{
                    textAlign: col.align ?? "left",
                  }}
                >
                  {col.accessor
                    ? col.accessor(row[col.key], row)
                    : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <div
          ref={endOfPageRef}
          style={{ padding: "4px", height: "10px" }}
        ></div>
      </table>
    </div>
  );
};
